export const getTodayDealEndTime = (baseDate = new Date()) => {
  const endOfDay = new Date(baseDate);

  endOfDay.setHours(23, 59, 59, 999);

  return endOfDay;
};
